import React, { useState } from "react";
import ReactDOMServer from 'react-dom/server';

import { isRunTime } from "../../utils/isRunTime";
import Icon from "../icon";

import CTAButton from "src/components/ctabutton/ctabutton";

export default function TruncateText({ text, characters = 200, buttonClosedText = "Show more", buttonOpenText = "Show less" }) {
  const [showFullText, setShowFullText] = useState(false);

  const toggleText = () => setShowFullText(!showFullText);

  const stripHtml = (input) => {
    if (typeof input === 'string' && isRunTime()) {
      const div = document.createElement('div');
      div.innerHTML = input;
      return div.textContent || div.innerText || '';
    } else {
      return ReactDOMServer.renderToString(input);
    }
  };

  const truncateText = (input, length) => {
    if (input.length <= length) {
      return input;
    }
  
    const lastSpaceIndex = input.lastIndexOf(' ', length);
    return input.slice(0, lastSpaceIndex);
  };
  
  let truncatedText = stripHtml(text);
  if (truncatedText.length > characters) {
    truncatedText = truncateText(truncatedText, characters);
  }

  const renderText = () => {
    if (typeof text === 'string') {
      if (showFullText) {
        return <div dangerouslySetInnerHTML={{ __html: text }} />;
      } else {
        return <div>{truncatedText} ...</div>;
      }
    } else {
      if (showFullText || stripHtml(text).length < characters) {
        return <div>{text}</div>;
      } else {
        return <div>{stripHtml(truncatedText)} ...</div>;
      }
    }
  };

  return (
    <div>
      {renderText()}
      {stripHtml(text).length > characters && (
        <CTAButton
          text={showFullText ? buttonOpenText : buttonClosedText}
          icon={<Icon icon={showFullText ? "ChevronUp": "ChevronDown"} />}
          onClick={() => toggleText()}
          className="items-end"
          type="soft"
          useButton={true}
        />
      )}
    </div>
  );
}